/* global modForm */
import { maskPhoneFields } from '../../../helpers';
/**
 * Init a one step form simulation for autofilling all inputs
 */
export function initAutofill() {
	const $zip = modForm.opts.form.querySelector('input[name="zip"]');

	if ($zip) {
		$zip.addEventListener('focus', function() {
			modForm.opts.steps.forEach(function(step) {
				if (step.classList.contains(modForm.opts.stepActiveCls)) {
					step.classList.add('autofill');
				}
			});
		});

		$zip.addEventListener('blur', function() {
			modForm.opts.steps.forEach(function(step) {
				step.classList.remove('autofill');
			});
			maskPhoneFields(modForm.opts.maskedPhoneFields);
		});
	}
}
